import "./TextBlock.css"

export type TextBlockProps = {
  children: any
}

export function TextBlock({ children }: TextBlockProps) {
  return (
    <div className="avlav-textblock">
      <p>{children}</p>
    </div>
  )
}
